import { BaseQueryParams } from 'types/types';
import { axiosInstance } from './apiCommon';
import { ToolStandardEpdOptionModel } from 'types/tools/ToolStandardEpdOptionModel';
import { ToolVersionStandardEpdOptionModel } from 'types/tools/ToolVersionStandardEpdOptionModel';
import { ToolCountersStatsForVersionModel } from 'types/tools/stats/ToolVersionStatsModel';
import { ToolVersionStatsType } from 'types/tools/stats/ToolVersionStatsType';
import { ToolVersionStatsEpd } from 'types/tools/stats/ToolVersionStatsEpd';

export const getCompanyTools = async (companyId: string, params: BaseQueryParams) =>
  (await axiosInstance.get<ToolStandardEpdOptionModel[]>(`/api/v1/tools/${encodeURIComponent(companyId)}`, params)).data;

export const getCompanyToolVersions = async (companyId: string, params: BaseQueryParams) =>
  (
    await axiosInstance.get<ToolVersionStandardEpdOptionModel[]>(
      `/api/v1/tools/${encodeURIComponent(companyId)}/versions`,
      params
    )
  ).data;

export const getToolVersionsStats = async (toolId: string, params: BaseQueryParams) =>
  (
    await axiosInstance.get<ToolCountersStatsForVersionModel[]>(
      `/api/v1/tools/${encodeURIComponent(toolId)}/version-stats`,
      params
    )
  ).data;

export const getToolVersionStatsEpds = async (
  toolId: string,
  versionOrd: number,
  type: ToolVersionStatsType,
  params: BaseQueryParams
) =>
  (
    await axiosInstance.get<ToolVersionStatsEpd[]>(
      `/api/v1/tools/${encodeURIComponent(toolId)}/versions/${versionOrd}/stats/${type}/epds`,
      params
    )
  ).data;
